import { Button, Col, Divider, Form, Row, Space } from "antd";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { AtualizarObservacaoAuditoriaContaFinanceiraModel } from "../../../../models/auditoriaContaFinanceira/atualizarObservacaoAuditoriaContaFinanceiraModel";
import { atualizarObservacaoAuditoriaContaFinanceira, cadastrarAuditoriaContaFinanceira } from "../../../../services/auditoriaContaFinanceiraService";
import { AuditoriaContaFinanceiraJsonModel } from "../../../../models/auditoriaContaFinanceira/auditoriaContaFinanceiraJsonModel";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import { useEffect } from "react";
import { AuditoriaContaFinanceiraDTOModel } from "../../../../models/auditoriaContaFinanceira/auditoriaContaFinanceiraDTOModel";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { setModalObservacaoAuditoriaContaFinanceira } from "../../../../redux/slices/auditoriaContaFinanceira/auditoriaContaFinanceiraSlice";
import dayjs from "dayjs";

dayjs.locale("pt-br");

const ObservacaoAuditoriaModal = () => {
  //estados globais
  const auditoriaContaFinanceiraState = useAppSelector((state) => state.auditoriaContaFinanceira);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(auditoriaContaFinanceiraState.entity).length !== 0;

  useEffect(() => {
    if (editar) {
      form.setFieldValue("observacao", auditoriaContaFinanceiraState.entity.observacao);
    }
  }, [auditoriaContaFinanceiraState.entity]);

  const submit = (value: any) => {
    if (editar) {
      const atualizarObservacao: AtualizarObservacaoAuditoriaContaFinanceiraModel = {
        idAuditoria: auditoriaContaFinanceiraState.entity.id,
        observacao: value.observacao,
      };
      dispatch(atualizarObservacaoAuditoriaContaFinanceira({ value: atualizarObservacao, busca: auditoriaContaFinanceiraState.busca }));
    } else {
      const rejeitarAuditoriaJson: AuditoriaContaFinanceiraJsonModel[] = [];
      auditoriaContaFinanceiraState.listSelecionada.forEach((v: any) => {
        var detalhes = {
          idContaFinanceira: v.id,
          codigoStatusAuditoria: "REJ",
          observacao: value.observacao,
          usuario: v.usuario,
        };
        rejeitarAuditoriaJson.push(detalhes);
      });
      const enviar: AuditoriaContaFinanceiraDTOModel = {} as AuditoriaContaFinanceiraDTOModel;
      enviar.auditoria = rejeitarAuditoriaJson;
      enviar.dataVencimento = dayjs(auditoriaContaFinanceiraState.entity.dataVencimento).format("DD/MM/YYYY");
      enviar.fornecedor = auditoriaContaFinanceiraState.entity.apelidoPessoa;
      enviar.valor = currencyBRL(auditoriaContaFinanceiraState.entity.valorBruto);
      enviar.usuarioContaFinanceira = auditoriaContaFinanceiraState.entity.usuarioContaFinanceira;
      dispatch(cadastrarAuditoriaContaFinanceira({ value: enviar, busca: auditoriaContaFinanceiraState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalObservacaoAuditoriaContaFinanceira(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item
            label="Observação"
            name="observacao"
            rules={[
              {
                required: true,
                message: "Digite o movito da auditoria da conta financeira",
              },
            ]}
          >
            <TextArea rows={3} />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default ObservacaoAuditoriaModal;
